import VojoAxios from '../../../settings/axios/VojoAxios'
import * as apiEndpoints from '../../../settings/apiEndpoints/vojoApi'

export const getApplicationList = async (data) => {
  try {
    const response = await VojoAxios.get(apiEndpoints.APPLICATION())
    return response.data.data
  } catch (errResponse) {
    const error = errResponse.response.data.error
    throw error
  }
}
